import { AgentInput, SuggestedQuestion } from './actions';

interface GlobalAskAicaService {
    openModalWithMessage: (message: string, flowKey?: string, agentInput?: AgentInput) => void;
    registerAskAicaInstance: (
        openModalFn: (message?: string, flowKey?: string, agentInput?: AgentInput) => void,
        sendMessageFn: (message: string, sources?: string[], flowKey?: string, agentInput?: AgentInput) => void,
    ) => void;
}

class AskAicaServiceImpl implements GlobalAskAicaService {
    private openModal: ((message?: string, flowKey?: string, agentInput?: AgentInput) => void) | null = null;
    private sendMessage: ((message: string, sources?: string[], flowKey?: string, agentInput?: AgentInput) => void) | null = null;

    registerAskAicaInstance(
        openModalFn: ((message?: string, flowKey?: string, agentInput?: AgentInput) => void) | null,
        sendMessageFn: ((message: string, sources?: string[], flowKey?: string, agentInput?: AgentInput) => void) | null,
    ): void {
        this.openModal = openModalFn;
        this.sendMessage = sendMessageFn;
    }

    openModalWithMessage(message: string, flowKey?: string, agentInput?: AgentInput): void {
        if (this.openModal && this.sendMessage) {
            this.openModal(message, flowKey, agentInput);
        } else {
            console.error('AskAica instance not registered. Make sure the global AskAicaV2 component is mounted.');
        }
    }
}

export const globalAskAicaService = new AskAicaServiceImpl();

export const handleSuggestedQuestionClick = (question: string | SuggestedQuestion, flowKey?: string, agentInput?: AgentInput): void => {
    const text = typeof question === 'string' ? question : question.text;
    const resolvedFlowKey = flowKey ?? (typeof question === 'string' ? undefined : question.flowKey);
    globalAskAicaService.openModalWithMessage(text, resolvedFlowKey, agentInput);
};
